<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="familiarForm">
        <v-container>
          <v-row>
            <v-col cols="6">
              <BaseInput v-model="familiar.nombre" :rules="required">
                <template v-slot:label>Nombre completo <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="maskedPhone" v-mask="'###-###-##-##'" maxlength="13" :rules="required">
                <template v-slot:label>Teléfono <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model.number="familiar.tiempoConocerse" type="number" min="0" :rules="required">
                <template v-slot:label>Tiempo de conocerse (años)<span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="familiar.comoConocio" :rules="required">
                <template v-slot:label>Cómo conoció a la persona <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="primary--text px-8 mb-4"
        :disabled="!familiarForm || loading"
        v-on:click="triggerSaveFamiliar()"
      >
        Registrar familiar
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import ReferenciaEntity from '@src/modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS } from '@modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
    },

    referencia: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      familiarForm: false,
      loading: false,
      maskedPhone: '',
      familiar: new ReferenciaEntity(TIPO_REFERENCIAS.PERSONAL),
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  mounted() {
    if (this.referencia) {
      this.familiar = { ...this.referencia }
      this.maskedPhone = this.referencia.telefono.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1-$2-$3-$4')
    }
  },

  methods: {
    ...mapActions('referenciaEnlaceC3', ['createReferencia', 'updateReferencia']),
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerSaveFamiliar() {
      try {
        this.loading = true
        this.familiar.telefono = this.maskedPhone.replace(/-/g, '')

        if (this.referencia) {
          await this.updateReferencia({ idPersonal: this.idPersonal, referencia: this.familiar })
        } else {
          await this.createReferencia({ idPersonal: this.idPersonal, referencia: this.familiar })
        }

        this.resetForm()
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar la referencia.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.familiar = new ReferenciaEntity()
      this.maskedPhone = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
